// Static copy/assets for the OpenPenguin Software landing page.

export const navLinks = [
  { label: "Plattform", href: "#about" },
  { label: "Funktionen", href: "#features" },
  { label: "Kanäle", href: "#integrations" },
  { label: "Pricing", href: "#pricing" },
  { label: "Community", href: "https://app.openpenguin.de/", badge: "Neu" },
];

export const brandName = "OpenPenguin";

export const logoImage =
  "/assets/openpenguin-logo.png";

export const hero = {
  titleLine1: "Die AI-Agent-Plattform",
  titleLine2Normal: "für Voice & ",
  titleLine2Italic: "Chatbots",
  subtitle: [
    "Baue, verwalte und verkaufe Voice-Agenten und Chatbots",
    "für deine Kunden — inklusive WhatsApp, Instagram und Facebook.",
  ],
  primaryCta: "Demo vereinbaren",
  secondaryCta: "Plattform ansehen",
};

// OpenPenguin dashboard image (blue theme) supplied by the user
export const dashboardImage =
  "/assets/openpenguin-dashboard.png";

export const treeImages = {
  ice: "https://images.unsplash.com/photo-1687904477461-3b38aeef9e54?w=1920&q=80",
};

export const whySection = {
  title: "Warum OpenPenguin?",
  subtitle: [
    "Alles, was eine AI-Agentur braucht, um Kundenprojekte sauber",
    "auszuliefern: Agenten, Kanäle, Pricing, Nutzer und Abrechnung.",
  ],
  poster: "/assets/platform-video-thumbnail.png",
  video:
    "https://player.vimeo.com/video/1201333226?h=02d75bfc8c&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1",
};

export const features = [
  {
    key: "analytics",
    badge: "analytics",
    title: "Voice-Agenten whitelabeln",
    description:
      "Verbinde ElevenLabs oder Retell AI, ordne fertige Voice-Agenten Kundenprojekten zu und verkaufe sie unter deiner eigenen Marke weiter.",
    bullets: [
      "ElevenLabs & Retell AI anbinden",
      "Agenten pro Kundenprojekt verwalten",
      "Eigene Preise und Pakete hinterlegen",
      "Usage, Minuten und Kosten im Blick behalten",
    ],
    reverse: false,
  },
  {
    key: "collab",
    badge: "collab",
    title: "Chatbots bauen und prompten",
    description:
      "Erstelle Chat-Agenten für Kunden, gib ihnen klare Prompts und Wissensgrundlagen und lasse sie Gespräche automatisch oder mit Human-Handoff bearbeiten.",
    bullets: [
      "OpenAI-Modelle pro Agent konfigurieren",
      "Prompts und Fallbacks zentral pflegen",
      "Wissensbasis für Kundeninhalte vorbereiten",
      "Gemeinsame Inbox für alle Gespräche",
    ],
    reverse: true,
  },
  {
    key: "task",
    badge: "task",
    title: "Kunden sauber ausrollen",
    description:
      "Lege Kundenprojekte an, lade mehrere Nutzer ein und entscheide pro Kunde, welche Bereiche später sichtbar und bearbeitbar sind.",
    bullets: [
      "Mehrere Nutzer pro Kundenprojekt",
      "Rollen und Berechtigungen vorbereiten",
      "Eigenes Kundenportal je Projekt",
      "Whitelabel-Branding für Agencies",
    ],
    reverse: false,
  },
];

export const testimonialsHeading = {
  line1: "Gebaut für Agencies,",
  line2: "die ausliefern",
};

export const testimonials = [
  {
    name: "Tom D",
    role: "Voice-Agent Reseller",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    quote:
      "OpenPenguin gibt uns endlich eine saubere Oberfläche, um Voice-Agenten nicht nur zu bauen, sondern als echtes Kundenprodukt zu verkaufen.",
  },
  {
    name: "Sarah L",
    role: "AI Automation Consultant",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    quote:
      "Statt für jeden Kunden alles neu zusammenzukleben, können wir Projekte, Agenten, Pricing und Zugänge an einem Ort verwalten.",
  },
  {
    name: "Lisa M",
    role: "Agency Owner",
    avatar: "https://randomuser.me/api/portraits/women/68.jpg",
    quote:
      "Der größte Unterschied ist das Whitelabel-Portal. Kunden sehen eine professionelle Plattform, nicht unsere internen Tools.",
  },
  {
    name: "Mark B",
    role: "Chatbot Builder",
    avatar: "https://randomuser.me/api/portraits/men/75.jpg",
    quote:
      "Die neue Chat-Schicht macht genau Sinn: ein Agent, mehrere Kanäle und eine Inbox, die WhatsApp, Instagram und Messenger zusammenbringt.",
  },
  {
    name: "James P",
    role: "Implementation Lead",
    avatar: "https://randomuser.me/api/portraits/men/11.jpg",
    quote:
      "Für uns zählt, dass die technische Komplexität im Hintergrund bleibt. Der Kunde bekommt ein klares Portal und wir behalten Kontrolle.",
  },
  {
    name: "Emily T",
    role: "Customer Success",
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
    quote:
      "Wenn ein Kunde einen neuen Kanal oder Nutzer braucht, passiert das im Projekt. Kein Chaos mehr mit verstreuten Tokens, Links und Tabellen.",
  },
];

export const partner = {
  title1: "Für Agencies,",
  title2: "die skalieren wollen",
  description:
    "OpenPenguin ist für AI-Dienstleister, die nicht jedes Kundenprojekt als Einzelanfertigung betreiben wollen. Baue wiederholbare Agenten-Produkte mit eigener Marke, eigenem Pricing und klaren Kundenportalen.",
  bullets: [
    "Eigene Kundenprojekte statt Tool-Chaos",
    "Voice-Agenten und Chatbots in einer Plattform",
    "WhatsApp, Instagram und Facebook Messenger als Kanäle",
  ],
  cta: "Partner-Demo anfragen",
  image: "/assets/openpenguin-antarctica-illustration.png",
};

export const pricing = {
  title: "Pricing für Agenturen",
  plans: [
    {
      name: "Starter",
      monthly: "Demo",
      yearly: "Demo",
      suffix: "",
      description: "Für erste Kundenprojekte und kleine AI-Agentur-Angebote.",
      features: ["Voice-Agenten verwalten", "Kundenportal", "OpenAI-Integration"],
      popular: false,
    },
    {
      name: "Agency",
      monthly: "Custom",
      yearly: "Custom",
      suffix: "",
      description: "Für Agencies, die mehrere Kunden mit eigener Marke betreuen.",
      features: ["Whitelabel-Branding", "Eigene Pricing-Pakete", "WhatsApp Chatbots"],
      popular: true,
    },
    {
      name: "Scale",
      monthly: "Custom",
      yearly: "Custom",
      suffix: "",
      description: "Für größere Setups mit mehreren Kanälen, Kunden und Integrationen.",
      features: ["Meta-Kanäle", "Priority Setup", "Individuelle Integrationen"],
      popular: false,
    },
  ],
};

export const faqs = [
  {
    question: "Für wen ist OpenPenguin gedacht?",
    answer:
      "OpenPenguin ist für AI-Agencies, Reseller und Consultants gebaut, die Voice-Agenten und Chatbots nicht nur einmalig einrichten, sondern als sauberes Kundenprodukt unter eigener Marke ausrollen wollen.",
  },
  {
    question: "Kann ich Voice-Agenten und Chatbots in einer Plattform verwalten?",
    answer:
      "Ja. Du kannst Voice-Agenten von ElevenLabs oder Retell AI whitelabeln und zusätzlich eigene Chatbots bauen, prompten und Kundenprojekten zuordnen.",
  },
  {
    question: "Welche Kanäle kann ich verbinden?",
    answer:
      "Der Fokus liegt auf WhatsApp, Instagram und Facebook Messenger für Chatbots. Für Voice-Agenten kannst du Telefonie-Setups über die angebundenen Voice-Anbieter und Nummern-Infrastruktur verwalten.",
  },
  {
    question: "Ist das Setup DSGVO-freundlich?",
    answer:
      "Die Plattform ist auf europäische Agencies ausgerichtet. Wir achten auf klare Mandantentrennung, kontrollierte Kundenzugänge und Infrastruktur mit deutschem Serverstandort in Frankfurt.",
  },
];

export const contact = {
  eyebrow: "Kontakt",
  titleLine1: "Lass uns dein",
  titleLine2: "Agenten-Setup planen",
  description:
    "Erzähl kurz, ob du Voice-Agenten, Chatbots oder beides als Whitelabel-Angebot verkaufen willst. Wir melden uns mit einem passenden Setup-Vorschlag für deine Agency.",
  bullets: [
    "Whitelabel-Plattform für deine Kunden",
    "Voice-Agenten, Chatbots und Meta-Kanäle",
    "Pricing, Nutzer und Projekte sauber verwalten",
  ],
  form: {
    name: "Vollständiger Name",
    namePlaceholder: "Max Mustermann",
    email: "Business E-Mail",
    emailPlaceholder: "max@agentur.de",
    company: "Agentur / Unternehmen",
    companyPlaceholder: "OpenPenguin Partner GmbH",
    message: "Worum geht es?",
    messagePlaceholder:
      "Wir möchten Voice-Agenten und WhatsApp-Chatbots für mehrere Kunden whitelabeln...",
    submit: "Demo anfragen",
    success: "Danke. Deine Anfrage ist vorbereitet.",
  },
};

export const footer = {
  contactTitle: "Kontakt",
  email: "info@openpenguin.de",
  phone: "Demo nach Vereinbarung",
  links: [
    { label: "Plattform", href: "#about" },
    { label: "Funktionen", href: "#features" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
  ],
  socials: [
    { label: "LinkedIn", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "Community", href: "https://app.openpenguin.de/" },
  ],
  legal: [
    { label: "Impressum", href: "/impressum" },
    { label: "AGB", href: "/agb" },
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "Datenlöschung", href: "/data-deletion" },
  ],
  line: "AI-Agent-Plattform für Voice-Agenten, Chatbots und Whitelabel-Kundenportale.",
};

export const legalPages = {
  impressum: {
    eyebrow: "Rechtliches",
    title: "Impressum",
    updated: "Letzte Aktualisierung: 12.07.2025",
    intro:
      "Angaben gemäß § 5 TMG für OpenPenguin, ein Angebot der Spalevic Consulting Kft.",
    sections: [
      {
        title: "Angaben gemäß § 5 TMG",
        content: [
          "Spalevic Consulting Kft.",
          "Lőcsei út 9/A",
          "1147 Budapest, Hungary",
        ],
        notes: [
          "OpenPenguin ist ein Angebot der Spalevic Consulting Kft.",
          "DestinyMedia GmbH, Pengoro UG, Voico AI GmbH & Spalevic Consulting Kft. sind Tochtergesellschaften der Spalevic & Partner Holding Kft.",
        ],
      },
      {
        title: "Kontakt",
        content: ["Telefon: +49 160 7763741", "E-Mail: info@aleksa.ai"],
      },
      {
        title: "Vertreten durch",
        content: ["Geschäftsführer (CEO): Aleksa Spalevic"],
      },
      {
        title: "Handelsregistereintrag",
        content: [
          "Handelsregister: Cg. 01-09-446084",
          "Registergericht: Amtsgericht Budapest",
          "USt-IdNr.: HU32852954",
          "Steuernummer: 32852954-2-42",
        ],
      },
      {
        title: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
        content: [
          "Aleksa Spalevic",
          "Révay utca 6. Fsz. 7. ajtó",
          "1065 Budapest",
          "Hungary",
        ],
      },
      {
        title: "Haftungsausschluss",
        groups: [
          {
            title: "Haftung für Inhalte",
            text: "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.",
          },
          {
            title: "Haftung für Links",
            text: "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
          },
          {
            title: "Urheberrecht",
            text: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.",
          },
        ],
      },
    ],
  },
  datenschutz: {
    eyebrow: "Rechtliches",
    title: "Datenschutzerklärung",
    updated: "Letzte Aktualisierung: 17.06.2026",
    intro:
      "Diese Datenschutzerklärung informiert darüber, welche personenbezogenen Daten beim Besuch dieser Website sowie bei der Nutzung der OpenPenguin-Agenten über WhatsApp, Instagram und Facebook Messenger verarbeitet werden.",
    sections: [
      {
        title: "1. Allgemeine Hinweise und Pflichtinformationen",
        content: [
          "Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:",
          "Spalevic Consulting Kft.",
          "Lőcsei út 9/A",
          "1147 Budapest, Hungary",
          "Telefon: +49 160 7763741",
          "E-Mail: info@aleksa.ai",
        ],
      },
      {
        title: "2. Erhebung und Speicherung personenbezogener Daten",
        groups: [
          {
            title: "2.1 Aufruf unserer Website",
            text: "Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.",
            list: [
              "IP-Adresse des anfragenden Rechners",
              "Datum und Uhrzeit des Zugriffs",
              "Name und URL der abgerufenen Datei",
              "Website, von der aus der Zugriff erfolgt",
              "Verwendeter Browser und ggf. Betriebssystem sowie Access-Provider",
            ],
          },
          {
            title: "2.2 Kontaktformular und Demo-Anfrage",
            text: "Wenn Sie uns per Kontaktformular oder Demo-Anfrage kontaktieren, werden Ihre Angaben inklusive der dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für Anschlussfragen bei uns gespeichert.",
          },
        ],
      },
      {
        title: "3. Analyse-Tools und Tools von Drittanbietern",
        groups: [
          {
            title: "3.1 PostHog",
            text: "Diese Website kann PostHog zur Produkt- und Website-Analyse einsetzen. Dabei können technische Nutzungsdaten verarbeitet werden, um zu verstehen, wie Besucher die Website nutzen und wie wir die Website verbessern können.",
          },
          {
            title: "3.2 Eingebundene externe Inhalte",
            text: "Soweit externe Dienste oder Inhalte eingebunden werden, kann es zu einer Verarbeitung technischer Zugriffsdaten durch diese Anbieter kommen. Externe Inhalte werden nur eingesetzt, wenn sie für Darstellung, Analyse oder Betrieb der Website erforderlich sind.",
          },
        ],
      },
      {
        title: "4. Hosting",
        content: [
          "Diese Website wird über Netlify bereitgestellt. Beim Besuch der Website können technische Zugriffsdaten verarbeitet werden, die für die sichere und stabile Auslieferung der Website erforderlich sind.",
        ],
      },
      {
        title: "5. Externe Dienstleister",
        groups: [
          {
            title: "Projektmanagement-Tool awork",
            text: "Wir nutzen awork (awork GmbH) für die gemeinsame Projektplanung und -durchführung mit unseren Kunden.",
          },
          {
            title: "CRM-System Pipedrive",
            text: "Wir nutzen Pipedrive (Pipedrive OÜ) zur Verwaltung unserer Kundenkontakte im B2B-Bereich. In diesem CRM speichern wir Kontaktinformationen, Kommunikation und Vertragsdetails.",
          },
        ],
      },
      {
        title:
          "6. Verarbeitung von Daten über Meta-Kanäle (WhatsApp, Instagram, Facebook Messenger)",
        content: [
          "Soweit über die OpenPenguin-Plattform Chat-Agenten auf den Meta-Kanälen WhatsApp Business, Instagram Direct und Facebook Messenger betrieben werden, verarbeiten wir die Daten der Nutzer, die mit diesen Agenten kommunizieren.",
        ],
        groups: [
          {
            title: "6.1 Welche Daten verarbeitet werden",
            text: "Wenn ein Nutzer eine Nachricht an einen über OpenPenguin betriebenen Agenten sendet, verarbeiten wir die folgenden Daten:",
            list: [
              "Profil- bzw. Anzeigename und Kanal-Kennung (z. B. WhatsApp-Telefonnummer, Instagram- oder Messenger-ID)",
              "Inhalt der gesendeten und empfangenen Nachrichten sowie der Konversationsverlauf",
              "Zeitstempel und technische Metadaten der Konversation",
            ],
          },
          {
            title: "6.2 Zweck und Rechtsgrundlage",
            text: "Die Verarbeitung dient dazu, eingehende Nachrichten zu empfangen, anzuzeigen, zu speichern und – soweit aktiviert – automatisiert zu beantworten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und lit. f DSGVO (Vertragserfüllung sowie berechtigtes Interesse an einer effizienten Kundenkommunikation).",
          },
          {
            title: "6.3 Herkunft der Daten und Rolle von Meta",
            text: "Die Daten werden über die Schnittstellen der Meta Platforms Ireland Ltd. (WhatsApp Business Platform, Instagram Graph API, Messenger Platform) übermittelt. Für die Datenverarbeitung durch Meta selbst gilt die Datenschutzrichtlinie von Meta.",
          },
          {
            title: "6.4 Auftragsverarbeitung im Whitelabel-Betrieb",
            text: "Nutzen Unternehmen die Plattform, um mit ihren eigenen Kunden zu kommunizieren, verarbeiten wir die Daten dieser Endkunden im Auftrag des jeweiligen Unternehmens als Auftragsverarbeiter gemäß Art. 28 DSGVO. Verantwortliche Stelle ist in diesem Fall das jeweilige Unternehmen.",
          },
          {
            title: "6.5 Speicherung und Löschung",
            text: "Die Konversationsdaten werden über unsere Plattform sowie die eingesetzten Hosting- und KI-Dienstleister (u. a. zur automatisierten Beantwortung) verarbeitet und gespeichert. Du kannst die Löschung deiner Daten jederzeit anfordern – die Anleitung dazu findest du unter /data-deletion.",
          },
        ],
      },
      {
        title: "7. Speicherdauer",
        content: [
          "Wir speichern personenbezogene Daten nur so lange, wie es zur Erreichung der jeweiligen Zwecke erforderlich ist oder wie es gesetzliche Aufbewahrungsfristen vorsehen.",
        ],
      },
      {
        title: "8. Ihre Rechte als betroffene Person",
        content: ["Sie haben das Recht auf:"],
        list: [
          "Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten",
          "Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten",
          "Löschung Ihrer bei uns gespeicherten personenbezogenen Daten",
          "Einschränkung der Verarbeitung Ihrer Daten",
          "Widerspruch gegen die Verarbeitung Ihrer Daten",
          "Datenübertragbarkeit",
        ],
      },
      {
        title: "9. Datensicherheit",
        content: [
          "Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.",
        ],
      },
      {
        title: "10. Aktualisierung und Änderung dieser Datenschutzerklärung",
        content: [
          "Diese Datenschutzerklärung ist aktuell gültig und wurde zuletzt am 17.06.2026 aktualisiert. Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht.",
        ],
      },
    ],
  },
  deletion: {
    eyebrow: "Rechtliches",
    title: "Datenlöschung",
    updated: "Letzte Aktualisierung: 17.06.2026",
    intro:
      "Hier erfährst du, wie du die Löschung deiner personenbezogenen Daten anfordern kannst – einschließlich der Daten, die über WhatsApp, Instagram oder den Facebook Messenger an einen mit OpenPenguin betriebenen Agenten übermittelt wurden.",
    sections: [
      {
        title: "1. Verantwortliche Stelle",
        content: [
          "Verantwortlich für die Verarbeitung und Löschung deiner Daten ist:",
          "Spalevic Consulting Kft.",
          "Lőcsei út 9/A",
          "1147 Budapest, Hungary",
          "E-Mail: info@aleksa.ai",
        ],
      },
      {
        title: "2. Welche Daten betroffen sind",
        content: [
          "Über die OpenPenguin-Plattform werden Nachrichten- und Konversationsdaten verarbeitet, die Nutzer an einen Voice- oder Chat-Agenten senden – auch über die Kanäle von Meta (WhatsApp, Instagram Direct und Facebook Messenger).",
        ],
        list: [
          "Name und Kanal-Kennung (z. B. WhatsApp-Telefonnummer, Instagram- oder Messenger-ID)",
          "Inhalt der ausgetauschten Nachrichten und der Konversationsverlauf",
          "Zeitstempel und technische Metadaten der Konversation",
        ],
      },
      {
        title: "3. So forderst du die Löschung an",
        content: [
          'Sende eine E-Mail mit dem Betreff "Datenlöschung" an info@aleksa.ai.',
          "Damit wir deine Anfrage eindeutig zuordnen können, gib bitte an:",
        ],
        list: [
          "den Kanal, über den du Kontakt hattest (WhatsApp, Instagram oder Facebook Messenger)",
          "die zugehörige Kennung (z. B. deine Telefonnummer oder deinen Benutzernamen)",
          "optional den ungefähren Zeitraum der Konversation",
        ],
        notes: [
          "Hinweis für Meta-Kanäle: Du kannst die Löschung auch direkt bei dem Unternehmen anfordern, mit dem du geschrieben hast. Dieses Unternehmen nutzt OpenPenguin als technischen Dienstleister (Auftragsverarbeitung). Wir leiten Löschanfragen bei Bedarf an die jeweils verantwortliche Stelle weiter.",
        ],
      },
      {
        title: "4. Ablauf und Frist",
        content: [
          "Nach Eingang deiner Anfrage identifizieren wir die zugehörigen personenbezogenen Daten und löschen sie aus den aktiven Systemen.",
          "Die Löschung erfolgt unverzüglich, spätestens innerhalb von 30 Tagen. Über den Abschluss informieren wir dich per E-Mail.",
        ],
        notes: [
          "Gesetzliche Aufbewahrungspflichten (z. B. steuer- und handelsrechtliche Fristen) können einer sofortigen Löschung einzelner Daten entgegenstehen. In diesem Fall werden die betroffenen Daten gesperrt und nach Ablauf der Frist gelöscht.",
        ],
      },
      {
        title: "5. Weitere Rechte",
        content: [
          "Neben der Löschung stehen dir weitere Betroffenenrechte zu: Auskunft, Berichtigung, Einschränkung der Verarbeitung, Widerspruch und Datenübertragbarkeit. Details findest du in unserer Datenschutzerklärung unter /datenschutz.",
        ],
      },
    ],
  },
  agb: {
    eyebrow: "Rechtliches",
    title: "Allgemeine Geschäftsbedingungen",
    updated: "Stand: 17.06.2026",
    intro:
      "Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der OpenPenguin-Plattform und der OpenPenguin-Community, einem Angebot der Spalevic Consulting Kft.",
    sections: [
      {
        title: "§ 1 Geltungsbereich und Vertragspartner",
        content: [
          "(1) Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für sämtliche Verträge über die Nutzung der unter openpenguin.de, platform.openpenguin.de sowie unter zugehörigen Subdomains angebotenen Leistungen (nachfolgend „OpenPenguin“), die zwischen der",
          "Spalevic Consulting Kft.",
          "Lőcsei út 9/A, 1147 Budapest, Ungarn",
          "Handelsregisternummer: Cg. 01-09-446084",
          "Steuernummer: 32852954-2-42",
          "USt-IdNr.: HU32852954",
          "Vertreten durch: Aleksa Spalevic (Geschäftsführer)",
          "E-Mail: info@aleksa.ai",
          "(nachfolgend „Anbieter“, „wir“ oder „OpenPenguin“) und ihren Kundinnen und Kunden (nachfolgend „Kunde“, „Nutzer“ oder „Mitglied“) geschlossen werden.",
          "(2) Die Leistungen des Anbieters richten sich sowohl an Unternehmer im Sinne des § 14 BGB bzw. vergleichbarer Regelungen des ungarischen Rechts (B2B) als auch an Verbraucher im Sinne des § 13 BGB (B2C).",
          "(3) Abweichende, entgegenstehende oder ergänzende Geschäftsbedingungen des Kunden werden nur dann Vertragsbestandteil, wenn der Anbieter ihrer Geltung ausdrücklich schriftlich zugestimmt hat.",
          "(4) Es gilt jeweils die zum Zeitpunkt des Vertragsschlusses gültige Fassung dieser AGB.",
        ],
      },
      {
        title: "§ 2 Leistungsgegenstand",
        content: [
          "(1) OpenPenguin ist eine Software-as-a-Service-Plattform (SaaS) sowie eine kostenpflichtige Online-Community rund um den Einsatz Künstlicher Intelligenz. Der konkrete Leistungsumfang ergibt sich aus der Leistungsbeschreibung auf der Website, dem gewählten Tarif und dem im Bestellprozess angezeigten Angebot.",
          "(2) Der Anbieter ist berechtigt, den Funktionsumfang, eingesetzte Tools und Drittanbieter im Rahmen des Zumutbaren weiterzuentwickeln und anzupassen, solange der vertraglich vereinbarte Leistungszweck nicht wesentlich beeinträchtigt wird.",
          "(3) Der Anbieter schuldet eine sorgfältige Bereitstellung der Plattform und der Community-Leistungen. Ein bestimmter wirtschaftlicher Erfolg des Kunden ist ausdrücklich nicht geschuldet.",
          "(4) Die Leistungen umfassen je nach gewähltem Tarif insbesondere:",
        ],
        list: [
          "Zugang zur Whitelabel-Plattform zum Erstellen und Betreiben von Voice-Agenten und Chatbots",
          "Anbindung von Kundenkanälen wie WhatsApp, Instagram und Facebook Messenger",
          "Funktionen zur Verwaltung eigener Kundenprojekte (Agency-/Whitelabel-Nutzung)",
          "Zugang zur privaten OpenPenguin-Community inklusive Feed, Events, Live-Sessions und Aufzeichnungen",
          "Zugriff auf digitale Kurse, Vorlagen, Blueprints und Claude-Skills",
          "Support über die in der Plattform bzw. Community vorgesehenen Kanäle",
        ],
      },
      {
        title: "§ 3 Registrierung, Nutzerkonto und Zustandekommen des Vertrags",
        content: [
          "(1) Die Darstellung der Leistungen auf der Website stellt kein rechtlich bindendes Angebot dar, sondern eine unverbindliche Aufforderung an den Kunden, ein Angebot abzugeben.",
          "(2) Für die Nutzung der Plattform ist die Anlage eines Nutzerkontos erforderlich. Der Kunde macht die abgefragten Angaben wahrheitsgemäß und vollständig und hält seine Zugangsdaten geheim.",
          "(3) Mit Abschluss des Bestellprozesses (Auswahl eines Tarifs, Eingabe der Zahlungsdaten und Anklicken der entsprechend bezeichneten Schaltfläche) gibt der Kunde ein verbindliches Angebot ab. Der Vertrag kommt mit der Bestätigung durch den Anbieter bzw. der Freischaltung des Zugangs zustande.",
          "(4) Vor Abgabe einer kostenpflichtigen Bestellung wird der Kunde klar und verständlich über die wesentlichen Merkmale der Leistung, den Gesamtpreis, die Laufzeit und die Bedingungen der Kündigung informiert (§ 312j BGB).",
        ],
      },
      {
        title: "§ 4 Kostenlose Testphase",
        content: [
          "(1) Der Anbieter kann eine kostenlose Testphase (Trial) anbieten. Die Dauer ergibt sich aus den Angaben im Bestellprozess. Für den Beginn der Testphase kann die Hinterlegung gültiger Zahlungsdaten verlangt werden.",
          "(2) Wird das kostenpflichtige Abonnement nicht vor Ablauf der Testphase gekündigt, geht es automatisch in ein kostenpflichtiges Abonnement zum gewählten Tarif über. Die erste Zahlung wird zu Beginn des ersten kostenpflichtigen Abrechnungszeitraums fällig.",
          "(3) Der Kunde kann die Testphase jederzeit innerhalb des Testzeitraums über sein Nutzerkonto ohne Angabe von Gründen beenden. Das gesetzliche Widerrufsrecht für Verbraucher (§ 8) bleibt unberührt.",
        ],
      },
      {
        title: "§ 5 Preise, Umsatzsteuer und Reverse-Charge-Verfahren",
        content: [
          "(1) Es gelten die im Bestellprozess bzw. im jeweiligen Tarif zum Zeitpunkt des Vertragsschlusses angegebenen Preise. Tarife können als „Founding“-Konditionen mit dauerhafter Preisgarantie für eine begrenzte Anzahl früher Mitglieder oder als reguläre Tarife ausgestaltet sein.",
          "(2) Sofern nicht ausdrücklich anders ausgewiesen, verstehen sich die Preise zuzüglich der jeweils gesetzlich geschuldeten Umsatzsteuer.",
          "(3) Kunden mit gültiger USt-IdNr. (B2B): Ist der Kunde Unternehmer mit Sitz innerhalb der EU und verfügt er über eine gültige USt-IdNr., erfolgt die Rechnungsstellung ohne Umsatzsteuer im Reverse-Charge-Verfahren gemäß Art. 196 der Richtlinie 2006/112/EG. Die Steuerschuld geht auf den Leistungsempfänger über.",
          "(4) Kunden ohne gültige USt-IdNr. (insbesondere Verbraucher): Da der Anbieter in Ungarn ansässig ist, unterliegen Leistungen an Kunden ohne gültige USt-IdNr. der gesetzlich anwendbaren Umsatzsteuer. Diese wird auf der Rechnung gesondert ausgewiesen.",
          "(5) Ändern sich steuerliche Rahmenbedingungen während der Vertragslaufzeit, ist der Anbieter berechtigt, die Bruttopreise entsprechend anzupassen. Etwaige Bank-, Transaktions- oder Wechselkursgebühren trägt der Kunde.",
        ],
      },
      {
        title: "§ 6 Zahlungsbedingungen",
        content: [
          "(1) Die Zahlung erfolgt grundsätzlich per Kredit- oder Debitkarte über den Zahlungsdienstleister Stripe. Der Kunde akzeptiert die geltenden Nutzungs- und Datenschutzbestimmungen von Stripe.",
          "(2) Bei Abonnements wird die Vergütung im Voraus für den jeweiligen Abrechnungszeitraum (monatlich, sofern nicht anders vereinbart) automatisch über das hinterlegte Zahlungsmittel eingezogen. Der Kunde hält ein gültiges Zahlungsmittel vor.",
          "(3) Der Anbieter darf den Zugang zur Plattform und zur Community aussetzen oder sperren, solange der Kunde mit einer fälligen Zahlung in Verzug ist.",
          "(4) Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in gesetzlicher Höhe sowie angemessene Mahnkosten geltend zu machen. Gegenüber Verbrauchern gelten die zwingenden gesetzlichen Regelungen.",
          "(5) Eine Aufrechnung mit Gegenforderungen ist nur zulässig, wenn diese rechtskräftig festgestellt, unbestritten oder vom Anbieter anerkannt sind.",
        ],
      },
      {
        title: "§ 7 Laufzeit, Verlängerung und Kündigung",
        content: [
          "(1) Abonnements werden für den im Bestellprozess angegebenen Zeitraum (in der Regel ein Monat) abgeschlossen und verlängern sich automatisch um jeweils einen weiteren gleich langen Zeitraum, sofern sie nicht vor Ablauf des laufenden Zeitraums gekündigt werden.",
          "(2) Der Kunde kann das Abonnement jederzeit zum Ende des laufenden Abrechnungszeitraums kündigen — über die dafür vorgesehene Schaltfläche im Nutzerkonto (Kündigungsbutton gemäß § 312k BGB) oder in Textform per E-Mail an info@aleksa.ai. Eine anteilige Rückerstattung bereits gezahlter Beträge erfolgt nicht, soweit gesetzlich zulässig.",
          "(3) Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt für beide Parteien unberührt. Der Anbieter ist hierzu insbesondere berechtigt, wenn der Kunde trotz Mahnung länger als 14 Tage in Zahlungsverzug ist, erheblich oder wiederholt gegen diese AGB, die zulässige Nutzung (§ 11) oder die Community-Regeln (§ 14) verstößt oder Zugangsdaten unberechtigt weitergibt.",
          "(4) Kündigungen bedürfen der Textform (E-Mail genügt), soweit kein Kündigungsbutton genutzt wird.",
        ],
      },
      {
        title: "§ 8 Widerrufsrecht für Verbraucher",
        content: [
          "(1) Widerrufsrecht. Verbrauchern steht bei Fernabsatzverträgen ein gesetzliches Widerrufsrecht zu. Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.",
          "Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Spalevic Consulting Kft., Lőcsei út 9/A, 1147 Budapest, Ungarn, E-Mail: info@aleksa.ai) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung vor Ablauf der Frist absenden.",
          "Folgen des Widerrufs. Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab Zugang Ihrer Widerrufsmitteilung zurückzuzahlen. Für die Rückzahlung verwenden wir dasselbe Zahlungsmittel wie bei der ursprünglichen Transaktion; Entgelte werden Ihnen wegen dieser Rückzahlung nicht berechnet.",
          "(2) Vorzeitiges Erlöschen des Widerrufsrechts. Das Widerrufsrecht erlischt bei Verträgen über die Bereitstellung digitaler Inhalte und digitaler Dienstleistungen, wenn der Anbieter mit der Ausführung begonnen hat, nachdem der Kunde (a) ausdrücklich zugestimmt hat, dass der Anbieter vor Ablauf der Widerrufsfrist mit der Ausführung beginnt, und (b) seine Kenntnis davon bestätigt hat, dass er durch diese Zustimmung mit Beginn der Ausführung sein Widerrufsrecht verliert. Diese Zustimmung wird im Bestellprozess ausdrücklich abgefragt.",
        ],
        notes: [
          "Muster-Widerrufsformular (wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden es zurück):",
          "An: Spalevic Consulting Kft., Lőcsei út 9/A, 1147 Budapest, Ungarn, info@aleksa.ai — Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung. Bestellt am / erhalten am: __ . Name des/der Verbraucher(s): __ . Anschrift: __ . Datum und Unterschrift (nur bei Mitteilung auf Papier): __ .",
        ],
      },
      {
        title: "§ 9 Verfügbarkeit, Wartung und Änderungen der Leistung",
        content: [
          "(1) Der Anbieter bemüht sich um eine möglichst hohe Verfügbarkeit der Plattform, schuldet jedoch keine ununterbrochene Verfügbarkeit. Ausgenommen sind Zeiten, in denen die Plattform aufgrund von Umständen außerhalb des Einflussbereichs des Anbieters (höhere Gewalt, Ausfälle von Drittanbietern oder Netzbetreibern) nicht erreichbar ist.",
          "(2) Der Anbieter darf notwendige Wartungs- und Aktualisierungsarbeiten durchführen und legt diese nach Möglichkeit in nutzungsschwache Zeiten bzw. kündigt sie rechtzeitig an.",
          "(3) Der Anbieter darf die Plattform fortentwickeln und einzelne Funktionen anpassen, hinzufügen oder einstellen, soweit dies dem Kunden zumutbar ist und den wesentlichen Leistungszweck nicht beeinträchtigt.",
        ],
      },
      {
        title: "§ 10 Mitwirkungspflichten und Account-Sicherheit",
        content: [
          "(1) Der Kunde ist für die Sicherheit seiner Zugangsdaten verantwortlich. Zugangsdaten sind persönlich und dürfen nicht an Dritte weitergegeben werden. Der Kunde informiert den Anbieter unverzüglich bei Verdacht auf unbefugten Zugriff.",
          "(2) Der Kunde stellt sicher, dass die von ihm eingebrachten Inhalte, Daten und Konfigurationen frei von Rechten Dritter sind und nicht gegen geltendes Recht verstoßen.",
          "(3) Soweit der Kunde eigene Zugänge zu Drittdiensten (z. B. Meta/WhatsApp, Telefonie, KI-Anbieter) anbindet, ist er für die Einhaltung der jeweiligen Nutzungsbedingungen dieser Dienste verantwortlich.",
        ],
      },
      {
        title: "§ 11 Zulässige Nutzung",
        content: [
          "(1) Der Kunde nutzt die Plattform nicht missbräuchlich.",
          "(2) Der Kunde stellt sicher, dass beim Einsatz von KI-gestützten Sprach- und Chat-Agenten die gesetzlichen Transparenzpflichten gegenüber Endnutzern eingehalten werden (insbesondere die Kennzeichnung der Kommunikation mit einem KI-System, soweit gesetzlich gefordert).",
          "(3) Bei Verstößen darf der Anbieter betroffene Inhalte entfernen, den Zugang vorübergehend sperren und in schweren Fällen außerordentlich kündigen (§ 7).",
          "Untersagt ist insbesondere:",
        ],
        list: [
          "der Einsatz von Voice-Agenten oder Chatbots für unzulässige Werbung, Spam oder Cold Calls ohne die erforderliche Einwilligung der kontaktierten Personen",
          "die Verarbeitung von Inhalten, die gegen geltendes Recht, Rechte Dritter oder die Richtlinien angebundener Plattformen (z. B. Meta, Telefonie-Anbieter) verstoßen",
          "jede Nutzung, die die Sicherheit, Integrität oder Verfügbarkeit der Plattform gefährdet",
          "das Umgehen technischer Schutzmaßnahmen oder das automatisierte Auslesen der Plattform über das vorgesehene Maß hinaus",
        ],
      },
      {
        title: "§ 12 Whitelabel- und Agency-Nutzung; Endkunden des Kunden",
        content: [
          "(1) Nutzt der Kunde die Plattform, um Leistungen gegenüber eigenen Kunden („Endkunden“) zu erbringen, bleibt der Kunde gegenüber seinen Endkunden alleiniger Vertragspartner und allein verantwortlich für Vertrags-, Preis- und Leistungsgestaltung sowie die Einhaltung der gegenüber Endkunden geltenden gesetzlichen Pflichten.",
          "(2) Der Anbieter tritt nicht in ein Vertragsverhältnis mit den Endkunden des Kunden. Der Kunde stellt den Anbieter von Ansprüchen frei, die Endkunden aufgrund der vom Kunden zu verantwortenden Leistungserbringung gegen den Anbieter geltend machen.",
          "(3) Soweit der Anbieter im Auftrag des Kunden personenbezogene Daten von Endkunden verarbeitet, schließen die Parteien einen Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO (AVV). Der AVV geht den Regelungen dieser AGB zur Verarbeitung von Endkundendaten vor.",
        ],
      },
      {
        title: "§ 13 Datenschutz",
        content: [
          "(1) Der Anbieter verarbeitet personenbezogene Daten ausschließlich im Rahmen der geltenden datenschutzrechtlichen Bestimmungen, insbesondere der DSGVO und des ungarischen Datenschutzrechts.",
          "(2) Ausführliche Informationen finden sich in der Datenschutzerklärung des Anbieters, abrufbar unter openpenguin.de/datenschutz. Die Datenschutzerklärung ist Bestandteil dieser AGB.",
        ],
      },
      {
        title: "§ 14 Community-Regeln und Verhaltenspflichten",
        content: [
          "(1) Die OpenPenguin-Community ist ein Ort des respektvollen Austauschs.",
          "(2) Der Anbieter darf bei Verstößen Beiträge entfernen, Verwarnungen aussprechen oder Mitglieder ausschließen. Bei schweren oder wiederholten Verstößen ist der Anbieter zur außerordentlichen Kündigung gemäß § 7 berechtigt.",
          "Jedes Mitglied verpflichtet sich:",
        ],
        list: [
          "andere Mitglieder respektvoll zu behandeln und keine diskriminierenden, beleidigenden oder rechtswidrigen Inhalte zu posten",
          "keine fremden Inhalte ohne ausreichende Rechte zu teilen",
          "keine unerwünschte Werbung für fremde Produkte oder Dienstleistungen zu machen",
          "Inhalte der Community (einschließlich Aufzeichnungen, Vorlagen, geteilter Dokumente) nicht außerhalb der Community zu verbreiten oder zu veröffentlichen",
        ],
      },
      {
        title: "§ 15 Nutzungsrechte an Inhalten; Drittanbieter",
        content: [
          "(1) Sämtliche vom Anbieter bereitgestellten Inhalte (Software, Kurse, Videos, Aufzeichnungen, Vorlagen, Blueprints, Skills, Folien und sonstige Materialien) sind urheberrechtlich geschützt. Der Kunde erhält ein einfaches, nicht übertragbares und nicht unterlizenzierbares Nutzungsrecht für die Dauer des Vertrags und im vertraglich vorgesehenen Umfang.",
          "(2) Inhalte und Vorlagen, die ausdrücklich als „zur freien Verwendung“ gekennzeichnet sind, darf der Kunde auch in eigenen kommerziellen Projekten einsetzen, jedoch nicht als eigenständige Produkte verkaufen oder öffentlich weiterverbreiten.",
          "(3) Die Plattform nutzt Leistungen von Drittanbietern (u. a. KI-Modellanbieter, Telefonie-, Messaging- und Zahlungsdienstleister, Hosting). Für deren Verfügbarkeit, Preisgestaltung und Richtlinienänderungen haftet der Anbieter nicht, soweit er diese nicht zu vertreten hat.",
        ],
      },
      {
        title: "§ 16 Gewährleistung",
        content: [
          "(1) Es gelten die gesetzlichen Gewährleistungsrechte. Gegenüber Verbrauchern gelten die zwingenden gesetzlichen Regelungen, insbesondere die Vorschriften über Verträge zur Bereitstellung digitaler Produkte (§§ 327 ff. BGB) bzw. das jeweils anwendbare nationale Verbraucherrecht.",
          "(2) Gegenüber Unternehmern beträgt die Gewährleistungsfrist zwölf Monate ab Leistungserbringung, soweit gesetzlich zulässig. Der Kunde zeigt Mängel unverzüglich an und gibt dem Anbieter angemessene Gelegenheit zur Nacherfüllung.",
        ],
      },
      {
        title: "§ 17 Haftung",
        content: [
          "(1) Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung des Anbieters, seiner gesetzlichen Vertreter oder Erfüllungsgehilfen beruhen.",
          "(2) Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) ist die Haftung auf den bei Vertragsschluss vorhersehbaren, vertragstypischen Schaden begrenzt. Eine weitergehende Haftung ist ausgeschlossen; insbesondere haftet der Anbieter nicht für entgangenen Gewinn, ausgebliebene Geschäftserfolge oder mittelbare Schäden.",
          "(3) Die Haftungsbeschränkungen gelten nicht, soweit der Anbieter einen Mangel arglistig verschwiegen oder eine Garantie übernommen hat. Die Haftung nach zwingenden gesetzlichen Vorschriften (insbesondere Produkthaftungsgesetz) bleibt unberührt.",
          "(4) Der Anbieter gibt keine Garantie für bestimmte geschäftliche Ergebnisse oder Erfolge des Kunden. Für den Ausfall von Diensten Dritter haftet der Anbieter nicht, es sei denn, der Ausfall ist von ihm zu vertreten.",
        ],
      },
      {
        title: "§ 18 Vertraulichkeit",
        content: [
          "(1) Beide Parteien halten alle im Rahmen der Vertragsdurchführung erlangten vertraulichen Informationen der jeweils anderen Partei geheim und verwenden sie nur für die Zwecke dieses Vertrags.",
          "(2) Die Vertraulichkeitsverpflichtung besteht auch nach Beendigung des Vertrags fort, solange und soweit die Informationen nicht öffentlich bekannt oder rechtmäßig ohne Verschwiegenheitsverpflichtung bekannt geworden sind.",
        ],
      },
      {
        title: "§ 19 Änderungen der AGB",
        content: [
          "(1) Der Anbieter darf diese AGB mit Wirkung für die Zukunft ändern, soweit dies aus rechtlichen, regulatorischen oder technischen Gründen erforderlich wird oder die Änderungen für den Kunden zumutbar sind und kein wesentliches Ungleichgewicht zwischen den Parteien schaffen.",
          "(2) Änderungen werden dem Kunden mindestens sechs Wochen vor Inkrafttreten in Textform mitgeteilt. Widerspricht der Kunde nicht innerhalb von sechs Wochen nach Zugang der Mitteilung, gelten die Änderungen als genehmigt; hierauf wird der Kunde in der Mitteilung gesondert hingewiesen. Widerspricht der Kunde fristgerecht, darf der Anbieter den Vertrag zum geplanten Inkrafttreten der Änderungen ordentlich kündigen.",
        ],
      },
      {
        title: "§ 20 Rechtswahl, Gerichtsstand und Online-Streitbeilegung",
        content: [
          "(1) Für sämtliche Verträge gilt ausschließlich ungarisches Recht unter Ausschluss des UN-Kaufrechts (CISG).",
          "(2) Ist der Kunde Verbraucher mit gewöhnlichem Aufenthalt innerhalb der EU, bleibt der durch zwingende Vorschriften des Rechts seines Aufenthaltsstaates gewährte Schutz unberührt (Art. 6 Abs. 2 Rom-I-Verordnung).",
          "(3) Ausschließlicher Gerichtsstand für Streitigkeiten mit Unternehmern, juristischen Personen des öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen ist der Sitz des Anbieters in Budapest, Ungarn. Für Verbraucher gelten die gesetzlichen Gerichtsstände.",
          "(4) Online-Streitbeilegung: Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung unter ec.europa.eu/consumers/odr bereit. Der Anbieter ist nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
        ],
      },
      {
        title: "§ 21 Schlussbestimmungen",
        content: [
          "(1) Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle der unwirksamen Bestimmung tritt eine Regelung, die dem wirtschaftlichen Zweck in rechtlich zulässiger Weise am nächsten kommt.",
          "(2) Änderungen und Ergänzungen des Vertrags bedürfen der Textform. Der Anbieter darf qualifizierte Unterauftragnehmer und Erfüllungsgehilfen einsetzen. Eine Übertragung der Rechte und Pflichten des Kunden auf Dritte bedarf der vorherigen Zustimmung des Anbieters.",
        ],
      },
    ],
  },
};

export const integrationsHeading = {
  line1: "Verbinde deine",
  line2: "Agenten-Kanäle",
  description:
    "Voice-Agenten, Chatbots und Kundenkommunikation laufen in einem System zusammen — von Telefon bis WhatsApp, Instagram und Facebook Messenger.",
};

export const integrations = [
  { name: "WhatsApp", logo: "https://cdn.simpleicons.org/whatsapp/25D366" },
  { name: "Instagram", logo: "https://cdn.simpleicons.org/instagram/E4405F" },
  { name: "Facebook", logo: "https://cdn.simpleicons.org/facebook/1877F2" },
  { name: "Messenger", logo: "https://cdn.simpleicons.org/messenger/00B2FF" },
  { name: "OpenAI", logo: "/assets/openai-logo.webp" },
  { name: "ElevenLabs", logo: "https://cdn.simpleicons.org/elevenlabs/111827" },
  { name: "Stripe", logo: "https://www.vectorlogo.zone/logos/stripe/stripe-icon.svg" },
  { name: "Twilio", logo: "/assets/twilio-logo.png" },
  { name: "Retell AI", logo: "https://cdn.simpleicons.org/voipdotms/5BA4FB" },
  { name: "Meta", logo: "https://cdn.simpleicons.org/meta/0467DF" },
];
export const logos = [
  "LOGO",
  "Logoipsum",
  "logo ipsum",
  "Logoipsum",
  "LOGO",
  "Logoipsum",
  "logo ipsum",
];
